import { render } from "./Ultima.vue?vue&type=template&id=5e31c4aa"
import script from "./Ultima.vue?vue&type=script&lang=js"
export * from "./Ultima.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__